module.exports = __webpack_public_path__ + "img/LapisLogo2.efb004b7.png";